export default {
  API_URL: (process.env.NODE_ENV === 'production')? 'https://api.nobiasinvesting.com/' : 'https://api.nobiasinvesting.com/',
  // API_URL: (process.env.NODE_ENV === 'production')? 'https://api.nobiasinvesting.com/' : 'http://192.168.2.213:5000/'
  //API_URL: (process.env.NODE_ENV === 'production')? 'http://localhost:5002/' : 'http://localhost:5002/'
};



// WEBPACK FOOTER //
// ./src/lib/config.js